import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ["data", "options"],
  watch: {
    data: function() {
      this.$data._chart.destroy();
      this.render();
    },
    options: function() {
      this.$data._chart.destroy();
      this.render();
    }
  },
  mounted() {
    this.render();
  },
  methods: {
    render: async function() {
      await this.renderChart(this.data, this.options);
    }
  }
};
